import script from "./SpecialismChip.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecialismChip.vue?vue&type=script&setup=true&lang=js"

import "./SpecialismChip.vue?vue&type=style&index=0&id=1e6cdaf4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e6cdaf4"]])

export default __exports__